import getVar from "@/business/livros/copiladores/getVar.js";
import Utils from "@/commons/Utils.js";

// mesmo marcador de nulo do backend (IParserList.agruparListaComposta)
const NULL_TOKEN = " ";

const agruparListaComposta = async function(node, callback, dicionario, debug){

  const listaOriginal = getVar(node.params.lista, dicionario, false);
  const lista = Array.isArray(listaOriginal) ? listaOriginal : [];

  const campos = String(node.params.por || "")
    .split(",")
    .map(campo => campo.trim())
    .filter(campo => campo.length > 0);

  const atributoSoma = node.params.somar;
  const somar = atributoSoma !== undefined && String(atributoSoma).trim().length > 0;

  // o Dicionario.translate do backend normaliza string vazia para nulo: ambos caem no marcador
  const valorChave = function(item, campo){
    const valor = getVar(campo, item, false, false, true);
    if(valor === undefined || valor === null){
      return NULL_TOKEN;
    }
    const texto = String(valor);
    return texto.trim().length > 0 ? texto : NULL_TOKEN;
  };

  // agrupa pela chave composta, preservando a ordem de primeira ocorrência
  const grupos = Utils.groupBy(lista, item => campos.map(campo => valorChave(item, campo)).join("||"));

  const somarGrupo = function(itens){
    let soma = new Utils.bigDecimal.BigDecimal(0);
    for(let item of itens){
      const valor = getVar(atributoSoma, item, false, false, true);
      if(valor === undefined || valor === null || String(valor).trim().length === 0){
        continue;
      }
      try{
        soma = soma.add(new Utils.bigDecimal.BigDecimal(String(valor)));
      }catch (e) {
        // valor não numérico: ignorado, como o try/catch do backend
      }
    }
    return soma.toString();
  };

  // mantém os campos do primeiro registro do grupo; só o atributo somado é substituído
  const novaLista = Object.keys(grupos).map(grupo => {
    const itens = grupos[grupo];
    const agregado = {...itens[0]};
    if(somar){
      agregado[atributoSoma] = somarGrupo(itens);
    }
    return agregado;
  });

  if(debug){
    debug.novaLista = novaLista;
  }

  // cria objeto de transporte
  let obj = {};
  obj[node.params.nome || 'lista'] = novaLista;

  return await callback(node.children, Utils.clone({...dicionario, ...obj}), debug);

};

export default agruparListaComposta;
